import type { FoodSubEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "components.favorite_summary.message.food."

interface Props {
  subEntry: FoodSubEntry;
}

export function FoodMessage(props: Props) {
  const {
    subEntry,
  } = props

  const polyglot = usePolyglot()

  return (
    <>
      {subEntry.food.title || polyglot.t(`${polyglotPrefix}fallback`)}
    </>
  )
}
